module.exports = __webpack_public_path__ + "static/assets/d8e209949482c369263a4566b2255248.png";